import { createFileRoute } from '@tanstack/react-router';
import { CustomerHealth } from '../../components/admin/CustomerHealth';

export const Route = createFileRoute('/admin/customer-health')({
  component: CustomerHealth,
});
